import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { APP_TITLE } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class TitleService {
  private readonly defaultTitle = APP_TITLE;
  
  constructor(private title: Title) {}

  setTitle(customTitle?: string) {
    if (customTitle) {
      this.title.setTitle(`${customTitle} | ${this.defaultTitle}`);
    } else {
      this.title.setTitle(this.defaultTitle);
    }
  }
}